import type { FC } from "react";

import styles from "./WalletBalanceCell.module.css";

import { BRAND_ICONS_URLS } from "../../../utils/Constants";

export interface WalletBalanceCellProps {
  balance: number | null | undefined;
  percentChange7d?: number | null;
}

const WalletBalanceCell: FC<WalletBalanceCellProps> = ({
  balance,
  percentChange7d,
}) => {
  const pct = percentChange7d ?? 0;
  const hasPct = !!pct;
  const pctColor =
    pct > 0
      ? "var(--green-400)"
      : pct < 0
        ? "var(--red-400)"
        : "inherit";
  const pctSign = pct > 0 ? "+" : "";

  const displayBalance =
    typeof balance === "number"
      ? balance.toLocaleString("en-US", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })
      : "0.00";

  return (
    <div className={styles.container}>
      <img
        src={
          process.env.REACT_APP_ADMIN_PANEL_CLOUDFRONT_URL +
          BRAND_ICONS_URLS.primaryCurrencySymbol
        }
        alt="cash icon"
        className={styles.currencyIcon}
      />
      <span>{displayBalance}</span>
      {hasPct && (
        <span className={styles.percentChange} style={{ color: pctColor }}>
          {pctSign}
          {pct.toFixed(1)}%
        </span>
      )}
    </div>
  );
};

export default WalletBalanceCell;
